// // src/components/SubCategoryModal.jsx
// import React, { useState, useEffect, useRef } from 'react';
// import { X, Upload, Crop, RotateCcw } from 'lucide-react';
// import ReactCrop from 'react-image-crop';
// import 'react-image-crop/dist/ReactCrop.css';

// const SubCategoryModal = ({ isOpen, onClose, onSubmit, editingSubCategory, topCategories }) => {
 
//   const [formData, setFormData] = useState({
//     name: '',
//     image: '',
//     topCategory: '',
//     hidden: false
//   });
//   const [imagePreview, setImagePreview] = useState('');
//   const [showCropper, setShowCropper] = useState(false);
//   const [crop, setCrop] = useState({
//     unit: '%',
//     width: 90,
//     height: 90,
//     x: 5,
//     y: 5
//   });
//   const [completedCrop, setCompletedCrop] = useState(null);
//   const [originalImage, setOriginalImage] = useState('');
//   const imgRef = useRef(null);
//   const canvasRef = useRef(null);

//   useEffect(() => {
//     if (editingSubCategory) {
//       setFormData({
//         name: editingSubCategory.name,
//         image: editingSubCategory.image,
//         topCategory: editingSubCategory.topCategory._id,
//         hidden: editingSubCategory.hidden || false
//       });
//       setImagePreview(editingSubCategory.image);
//     } else {
//       setFormData({ name: '', image: '', topCategory: '', hidden: false });
//       setImagePreview('');
//     }
//   }, [editingSubCategory]);

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setOriginalImage(reader.result);
//         setImagePreview(reader.result);
//         setShowCropper(true);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const getCroppedImg = (image, crop, fileName = 'cropped.jpg') => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext('2d');
//     const img = imgRef.current;

//     if (!crop || !canvas || !img) return null;

//     const scaleX = img.naturalWidth / img.width;
//     const scaleY = img.naturalHeight / img.height;
//     const pixelRatio = window.devicePixelRatio;

//     canvas.width = crop.width * pixelRatio * scaleX;
//     canvas.height = crop.height * pixelRatio * scaleY;

//     ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
//     ctx.imageSmoothingQuality = 'high';

//     ctx.drawImage(
//       img,
//       crop.x * scaleX,
//       crop.y * scaleY,
//       crop.width * scaleX,
//       crop.height * scaleY,
//       0,
//       0,
//       crop.width * scaleX,
//       crop.height * scaleY
//     );

//     return new Promise((resolve) => {
//       canvas.toBlob((blob) => {
//         if (!blob) {
//           console.error('Canvas is empty');
//           return;
//         }
//         const reader = new FileReader();
//         reader.onloadend = () => resolve(reader.result);
//         reader.readAsDataURL(blob);
//       }, 'image/jpeg', 0.9);
//     });
//   };

//   const handleCropConfirm = async () => {
//     if (completedCrop && imgRef.current) {
//       const croppedImage = await getCroppedImg(imgRef.current, completedCrop);
//       setImagePreview(croppedImage);
//       setFormData({ ...formData, image: croppedImage });
//       setShowCropper(false);
//     }
//   };

//   const handleCropCancel = () => {
//     setShowCropper(false);
//     setImagePreview('');
//     setFormData({ ...formData, image: '' });
//   };

//   const handleResetCrop = () => {
//     setCrop({
//       unit: '%',
//       width: 90,
//       height: 90,
//       x: 5,
//       y: 5
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (formData.name && formData.image && formData.topCategory) {
//       // Convert base64 to File object for API
//       const dataURLtoFile = (dataurl, filename) => {
//         const arr = dataurl.split(',');
//         const mime = arr[0].match(/:(.*?);/)[1];
//         const bstr = atob(arr[1]);
//         let n = bstr.length;
//         const u8arr = new Uint8Array(n);
//         while (n--) {
//           u8arr[n] = bstr.charCodeAt(n);
//         }
//         return new File([u8arr], filename, { type: mime });
//       };

//       const submitData = {
//         ...formData,
//         image: typeof formData.image === 'string' && formData.image.startsWith('data:') 
//           ? dataURLtoFile(formData.image, 'subcategory-image.jpg')
//           : formData.image
//       };

//       onSubmit(submitData);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//       <div className="bg-white rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
//         <div className="flex items-center justify-between p-4 border-b">
//           <h3 className="text-lg font-semibold">
//             {editingSubCategory ? 'Edit Sub-Category' : 'Add New Sub-Category'}
//           </h3>
//           <button
//             onClick={onClose}
//             className="p-1 hover:bg-gray-100 rounded-full"
//           >
//             <X className="w-5 h-5" />
//           </button>
//         </div>
        
//         <form onSubmit={handleSubmit} className="p-4">
//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">
//               Sub-Category Image
//             </label>
            
//             {showCropper ? (
//               <div className="space-y-4">
//                 <div className="border border-gray-300 rounded-lg overflow-hidden">
//                   <ReactCrop
//                     crop={crop}
//                     onChange={(pixelCrop, percentCrop) => setCrop(percentCrop)}
//                     onComplete={(c) => setCompletedCrop(c)}
//                     aspect={1}
//                     minWidth={50}
//                     minHeight={50}
//                   >
//                     <img
//                       ref={imgRef}
//                       alt="Crop preview"
//                       src={originalImage}
//                       className="max-w-full max-h-96 object-contain"
//                     />
//                   </ReactCrop>
//                 </div>
                
//                 <div className="flex gap-2 justify-center">
//                   <button
//                     type="button"
//                     onClick={handleResetCrop}
//                     className="px-3 py-1 bg-gray-100 hover:bg-gray-200 rounded-md text-sm flex items-center gap-1"
//                   >
//                     <RotateCcw className="w-4 h-4" />
//                     Reset
//                   </button>
//                   <button
//                     type="button"
//                     onClick={handleCropCancel}
//                     className="px-3 py-1 bg-red-100 hover:bg-red-200 text-red-700 rounded-md text-sm"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="button"
//                     onClick={handleCropConfirm}
//                     className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm flex items-center gap-1"
//                   >
//                     <Crop className="w-4 h-4" />
//                     Apply Crop
//                   </button>
//                 </div>
//               </div>
//             ) : (
//               <div className="border-2 border-dashed border-gray-300 rounded-lg p-4">
//                 {imagePreview ? (
//                   <div className="relative">
//                     <img
//                       src={imagePreview}
//                       alt="Preview"
//                       className="w-full h-32 object-contain rounded"
//                     />
//                     <button
//                       type="button"
//                       onClick={() => {
//                         setImagePreview('');
//                         setFormData({ ...formData, image: '' });
//                       }}
//                       className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full hover:bg-red-600"
//                     >
//                       <X className="w-4 h-4" />
//                     </button>
//                     <button
//                       type="button"
//                       onClick={() => {
//                         setOriginalImage(imagePreview);
//                         setShowCropper(true);
//                       }}
//                       className="absolute top-2 left-2 bg-blue-500 text-white p-1 rounded-full hover:bg-blue-600"
//                     >
//                       <Crop className="w-4 h-4" />
//                     </button>
//                   </div>
//                 ) : (
//                   <label className="flex flex-col items-center cursor-pointer hover:bg-gray-50 p-4 rounded">
//                     <Upload className="w-8 h-8 text-gray-400 mb-2" />
//                     <span className="text-sm text-gray-500 mb-1">Click to upload image</span>
//                     <span className="text-xs text-gray-400">PNG, JPG up to 5MB</span>
//                     <input
//                       type="file"
//                       accept="image/*"
//                       onChange={handleImageChange}
//                       className="hidden"
//                     />
//                   </label>
//                 )}
//               </div>
//             )}
//           </div>

//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">
//               Sub-Category Name
//             </label>
//             <input
//               type="text"
//               value={formData.name}
//               onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//               className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none 
//                        focus:ring-2 focus:ring-blue-500"
//               placeholder="Enter sub-category name"
//               required
//             />
//           </div>

//           <div className="mb-4">
//             <label className="block text-sm font-medium text-gray-700 mb-2">
//               Parent Category
//             </label>
//             <select
//               value={formData.topCategory}
//               onChange={(e) => setFormData({ ...formData, topCategory: e.target.value })}
//               className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none 
//                        focus:ring-2 focus:ring-blue-500"
//               required
//             >
//               <option value="">Select a category</option>
//               {topCategories.map((category) => (
//                 <option key={category.id || category._id} value={category.id || category._id}>
//                   {category.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className="mb-6">
//             <label className="flex items-center gap-2">
//               <input
//                 type="checkbox"
//                 checked={formData.hidden || false}
//                 onChange={(e) => setFormData({ ...formData, hidden: e.target.checked })}
//                 className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
//               />
//               <span className="text-sm text-gray-700">Hide this sub-category</span>
//             </label>
//           </div>

//           <div className="flex gap-3 justify-end">
//             <button
//               type="button"
//               onClick={onClose}
//               className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={showCropper}
//               className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 
//                        disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
//             >
//               {editingSubCategory ? 'Update' : 'Add'} Sub-Category
//             </button>
//           </div>
//         </form>
        
//         {/* Hidden canvas for cropping */}
//         <canvas ref={canvasRef} style={{ display: 'none' }} />
//       </div>
//     </div>
//   );
// };

// export default SubCategoryModal;
// src/components/SubCategoryModal.jsx
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { X, Upload, Crop, RotateCcw, Maximize } from 'lucide-react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

const SubCategoryModal = ({ isOpen, onClose, onSubmit, editingSubCategory, topCategories }) => {
  const [formData, setFormData] = useState({
    name: '',
    image: '',
    topCategory: '',
    hidden: false
  });
  const [imagePreview, setImagePreview] = useState('');
  const [showCropper, setShowCropper] = useState(false);
  // const [cropMode, setCropMode] = useState(false);
  const [crop, setCrop] = useState({
    unit: '%',
    width: 80,
    height: 80,
    x: 10,
    y: 10
  });
  const [completedCrop, setCompletedCrop] = useState(null);
  const [originalImage, setOriginalImage] = useState('');
  // const [imageLoaded, setImageLoaded] = useState(false);
  const imgRef = useRef(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    if (editingSubCategory) {
      setFormData({
        name: editingSubCategory.name,
        image: editingSubCategory.image,
        topCategory: editingSubCategory.topCategory?._id || editingSubCategory.topCategory || editingSubCategory.categoryId || '',
        hidden: editingSubCategory.hidden || false
      });
      setImagePreview(editingSubCategory.image);
      setOriginalImage(editingSubCategory.image);
    } else {
      setFormData({ name: '', image: '', topCategory: '', hidden: false });
      setImagePreview('');
      setOriginalImage('');
    }
    // setCropMode(false);
    setShowCropper(false);
  }, [editingSubCategory]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setOriginalImage(reader.result);
        setImagePreview(reader.result);
        // setCropMode(false);
        setShowCropper(false);
        // setImageLoaded(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const onImageLoad = useCallback(() => {
    if (imgRef.current) {
      const newCrop = {
        unit: '%',
        width: 80,
        height: 80,
        x: 10,
        y: 10
      };
      setCrop(newCrop);
      setCompletedCrop(newCrop);
    }
  }, []);

  const getCroppedImg = async (image, crop) => {
    const canvas = canvasRef.current;
    const img = imgRef.current;

    if (!crop || !canvas || !img) return null;

    const scaleX = img.naturalWidth / img.width;
    const scaleY = img.naturalHeight / img.height;
    const pixelRatio = window.devicePixelRatio || 1;

    canvas.width = Math.floor(crop.width * scaleX);
    canvas.height = Math.floor(crop.height * scaleY);

    const ctx = canvas.getContext('2d');
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = 'high';

    const cropX = crop.x * scaleX;
    const cropY = crop.y * scaleY;
    const cropWidth = crop.width * scaleX;
    const cropHeight = crop.height * scaleY;

    ctx.drawImage(
      img,
      cropX,
      cropY,
      cropWidth,
      cropHeight,
      0,
      0,
      cropWidth,
      cropHeight
    );

    return new Promise((resolve) => {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            console.error('Canvas is empty');
            return;
          }
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        },
        'image/jpeg',
        0.95
      );
    });
  };

  const handleUseFull = () => {
    setImagePreview(originalImage);
    setFormData({ ...formData, image: originalImage });
    // setCropMode(false);
    setShowCropper(false);
  };

  const handleStartCrop = () => {
    // setCropMode(true);
    setShowCropper(true);
    // setImageLoaded(true);
  };

  const handleCropConfirm = async () => {
    if (completedCrop && imgRef.current && completedCrop.width && completedCrop.height) {
      try {
        const croppedImage = await getCroppedImg(imgRef.current, completedCrop);
        if (croppedImage) {
          setImagePreview(croppedImage);
          setFormData({ ...formData, image: croppedImage });
          setShowCropper(false);
          // setCropMode(false);
        }
      } catch (error) {
        console.error('Error cropping image:', error);
      }
    }
  };

  const handleCropCancel = () => {
    setShowCropper(false);
    // setCropMode(false);
    if (!imagePreview || imagePreview === originalImage) {
      setImagePreview('');
      setFormData({ ...formData, image: '' });
    }
  };

  const handleResetCrop = () => {
    const newCrop = {
      unit: '%',
      width: 80,
      height: 80,
      x: 10,
      y: 10
    };
    setCrop(newCrop);
    setCompletedCrop(newCrop);
  };

  const handleRemoveImage = () => {
    setImagePreview('');
    setOriginalImage('');
    setFormData({ ...formData, image: '' });
    setShowCropper(false);
    // setCropMode(false);
  };

  const resetForm = () => {
  setFormData({
    name: '',
    image: '',
    topCategory: '',
    hidden: false
  });
  setImagePreview('');
  setOriginalImage('');
  setShowCropper(false);
  setCrop({
    unit: '%',
    width: 80,
    height: 80,
    x: 10,
    y: 10
  });
  setCompletedCrop(null);
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.name && formData.image && formData.topCategory) {
      const dataURLtoFile = (dataurl, filename) => {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
      };

      const submitData = {
        ...formData,
        image: typeof formData.image === 'string' && formData.image.startsWith('data:') 
          ? dataURLtoFile(formData.image, 'subcategory-image.jpg')
          : formData.image
      };

    try {
      await onSubmit(submitData);   // ✅ wait for success
      resetForm();                  // ✅ RESET HERE
    } catch (err) {
      console.error(err);
    }
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg w-full max-w-4xl max-h-[95vh] overflow-y-auto">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-semibold">
            {editingSubCategory ? 'Edit Sub-Category' : 'Add New Sub-Category'}
          </h3>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="p-4">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Sub-Category Image
            </label>
            
            {showCropper ? (
              <div className="space-y-4">
                <div className="border border-gray-300 rounded-lg overflow-hidden bg-gray-50">
                  <ReactCrop
                    crop={crop}
                    onChange={(newCrop) => setCrop(newCrop)}
                    onComplete={(c) => setCompletedCrop(c)}
                    aspect={1}
                    minWidth={50}
                    minHeight={50}
                    keepSelection={true}
                  >
                    <img
                      ref={imgRef}
                      alt="Crop preview"
                      src={originalImage}
                      onLoad={onImageLoad}
                      className="max-w-full max-h-[400px] object-contain mx-auto"
                    />
                  </ReactCrop>
                </div>
                
                <div className="flex gap-2 justify-center flex-wrap">
                  <button
                    type="button"
                    onClick={handleResetCrop}
                    className="px-3 py-2 bg-gray-100 hover:bg-gray-200 rounded-md text-sm flex items-center gap-2"
                  >
                    <RotateCcw className="w-4 h-4" />
                    Reset Crop
                  </button>
                  <button
                    type="button"
                    onClick={handleUseFull}
                    className="px-3 py-2 bg-green-100 hover:bg-green-200 text-green-700 rounded-md text-sm flex items-center gap-2"
                  >
                    <Maximize className="w-4 h-4" />
                    Use Full Image
                  </button>
                  <button
                    type="button"
                    onClick={handleCropCancel}
                    className="px-3 py-2 bg-red-100 hover:bg-red-200 text-red-700 rounded-md text-sm"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={handleCropConfirm}
                    className="px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm flex items-center gap-2"
                  >
                    <Crop className="w-4 h-4" />
                    Apply Crop
                  </button>
                </div>
              </div>
            ) : (
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-4">
                {imagePreview ? (
                  <div className="relative">
                    <img
                      src={imagePreview}
                      alt="Preview"
                      className="w-full h-48 object-contain rounded mx-auto"
                    />
                    <div className="absolute top-2 right-2 flex gap-2">
                      <button
                        type="button"
                        onClick={handleRemoveImage}
                        className="bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-colors"
                      >
                        <X className="w-4 h-4" />
                      </button>
                      <button
                        type="button"
                        onClick={handleStartCrop}
                        className="bg-blue-500 text-white p-2 rounded-full hover:bg-blue-600 transition-colors"
                      >
                        <Crop className="w-4 h-4" />
                      </button>
                    </div>
                    <div className="mt-3 flex gap-2 justify-center">
                      <button
                        type="button"
                        onClick={handleUseFull}
                        className="px-3 py-1 bg-green-100 hover:bg-green-200 text-green-700 rounded text-sm flex items-center gap-1"
                      >
                        <Maximize className="w-3 h-3" />
                        Use Full Image
                      </button>
                      <button
                        type="button"
                        onClick={handleStartCrop}
                        className="px-3 py-1 bg-blue-100 hover:bg-blue-200 text-blue-700 rounded text-sm flex items-center gap-1"
                      >
                        <Crop className="w-3 h-3" />
                        Crop Image
                      </button>
                    </div>
                  </div>
                ) : (
                  <label className="flex flex-col items-center cursor-pointer hover:bg-gray-50 p-8 rounded transition-colors">
                    <Upload className="w-12 h-12 text-gray-400 mb-3" />
                    <span className="text-lg text-gray-600 mb-2">Click to upload image</span>
                    <span className="text-sm text-gray-400">PNG, JPG up to 5MB</span>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      className="hidden"
                    />
                  </label>
                )}
              </div>
            )}
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Sub-Category Name
            </label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none 
                       focus:ring-2 focus:ring-blue-500"
              placeholder="Enter sub-category name"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Parent Category
            </label>
            <select
              value={formData.topCategory}
              onChange={(e) => setFormData({ ...formData, topCategory: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none 
                       focus:ring-2 focus:ring-blue-500"
              required
            >
              <option value="">Select a category</option>
              {topCategories.map((category) => (
                <option key={category._id || category.id} value={category._id || category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-6">
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={formData.hidden || false}
                onChange={(e) => setFormData({ ...formData, hidden: e.target.checked })}
                className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
              />
              <span className="text-sm text-gray-700">Hide this sub-category</span>
            </label>
          </div>

          <div className="flex gap-3 justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={showCropper}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 
                       disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
            >
              {editingSubCategory ? 'Update' : 'Add'} Sub-Category
            </button>
          </div>
        </form>
        
        {/* Hidden canvas for cropping */}
        <canvas ref={canvasRef} style={{ display: 'none' }} />
      </div>
    </div>
  );
};

export default SubCategoryModal;
